import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { FieldError } from 'react-hook-form';
import { getErrorMessage } from '@utils/formErrorHandler';

interface FormErrorDisplayProps {
  error?: FieldError;
  className?: string;
}

/**
 * Reusable component for displaying form field errors
 * Handles both client-side and server-side validation errors
 */
export const FormErrorDisplay: React.FC<FormErrorDisplayProps> = ({ 
  error, 
  className 
}) => {
  if (!error) return null;

  const errorMessage = error.type === 'server' 
    ? getErrorMessage(error.message || '') 
    : error.message;

  return (
    <Text 
      color="red.500" 
      fontSize="sm" 
      mt={1}
      className={className}
    >
      {errorMessage}
    </Text>
  );
};

interface RootErrorDisplayProps {
  error?: { message?: string };
  className?: string;
}

/**
 * Component for displaying root/general form errors
 */
export const RootErrorDisplay: React.FC<RootErrorDisplayProps> = ({ 
  error, 
  className 
}) => {
  if (!error?.message) return null;

  return (
    <Box className={className}>
      <Text 
        color="red.500" 
        fontSize="sm" 
        textAlign="center" 
        p={3} 
        bg="red.50" 
        _dark={{ bg: "red.900" }} 
        rounded="md"
      >
        {error.message}
      </Text>
    </Box>
  );
};

export default FormErrorDisplay; 